import React from 'react';
import { connect } from 'react-redux'

import HistoryDetails from "../components/HistoryDetails"
import Loader from "../components/modals/loader"
import Mitigator from '../components/modals/mitigator'
import ReportRemover from "../components/modals/report_remover"
import ReportRemoverConfirm from "../components/modals/report_remover_confirm"
import LicenseFixer from '../components/modals/license_fixer'
import LicenseCopyright from '../components/modals/license_copyright';
import {setCopyrightLicense, setLicenseToFix} from '../state/actions/exclusions'
import {showCloseModalConfirmation, setCloseModalConfirmCb} from "../state/actions/modals"
import ModalCloseConfirmation from '../components/modals/ModalCloseConfirmation';
import JiraIssueModal from "../components/modals/jira_issue";
import LocationsModal from "../components/modals/locations"
import ApproveLibraryModal from "../components/modals/approve_library"

const mapStateToProps = state => ({
	exclusionElement: state.elementExclusion.element,
	action: state.elementExclusion.action,
	licenseToFix: state.licenseFix.licenseToFix,
	isGlobalExclusionAvailable: state.elementExclusion.isGlobalExclusionAvailable,
	historyData: state.historyData,
	library: state.copyrightLicense.library,
	isMultiple: state.elementExclusion.isMultiple,
	confirmModal: state.modalState.confirmModal,
	accountInfo: state.setUser.user.account
})

const mapStateAsDemitigatorProps = state => ({
	exclusions: state.projectInfo.exclusions,
})
const mapDispatchAsProps = dispatch=>({
	setCopyrightLicense: (library) => dispatch(setCopyrightLicense(library)),
	setLicenseToFix: () => dispatch(setLicenseToFix()),
	showCloseModalConfirmation: (showModal) => dispatch(showCloseModalConfirmation(showModal)),
	setCloseModalConfirmCb: (confirmCb) => dispatch(setCloseModalConfirmCb(confirmCb))
})

let confirmedExclusion;
const DemitigatorConfirm = ({ removeMitigation }) => {
	return (

		<div className="modal fade" id="exclude-confirm-dialog" tabIndex="-1" role="dialog">
			<div className="modal-dialog modal-dialog-centered" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h4 id="exclude-title" className="modal-title">Warning</h4>
						<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
					</div>

					<div className="modal-body">
						This exclusion is linked to all the other versions of this library.<br />
						Are you sure you want to remove it?
					</div>

					<div className="modal-footer">
						<button type="button" className="btn btn-default" data-dismiss="modal">Cancel</button>
						<button type="button" className="btn btn-primary" id="exclude-confirm-submit" data-dismiss="modal" onClick={async () => { await removeMitigation(confirmedExclusion, false, true, true, this.state.doRecompute); confirmedExclusion = null }} >Exclude</button>
					</div>
				</div>
			</div>
		</div>
	)
}


const Demitigator = connect(mapStateAsDemitigatorProps)(class extends React.Component {

	constructor(props) {
		super(props)



		this.restoreComponent = React.createRef();
		this.globalExclusion = false;
		this.type = null;
		this.state = { id: 1, doRecompute: false }
		this.autoRecompute = React.createRef();

	}

	setGlobalExclusion = (e) => {
		this.globalExclusion = e.target.checked;
	}

	setDefault = () => {
		window.$(this.restoreComponent.current).prop('checked', false);
		this.globalExclusion = false;
	}

	countAdvisoriesWithExclusionType(advisories, type){
		let count = 0
		for (const advice of advisories){
			for ( const exclusion of advice.exclusions ) {
				if(exclusion.source.includes(type)) {
					count ++
					continue
				}
			}
		}
		return count - 1
	}

	doRemoveMitigation = async (exclusionElement) => {
		const { removeMitigation } = this.props;
		const { report } = this.props.exclusionElement
		if (exclusionElement.domain === "security") {
			if (this.globalExclusion) {
				if (this.type === "advice") {
					const all = this.countAdvisoriesWithExclusionType(report.advices, "advice");
					let counter = all;
					for (const advice of report.advices) {
						if (!advice.exclusions) {
							advice.exclusions = []
						}
						for (const exclusion of advice.exclusions) {
							if (exclusion.source === "security:advices") {
								await removeMitigation(exclusion.id, false, counter === all, counter === 0, this.state.doRecompute);
							}
							counter--;
						}
					}
				}
				if (this.type === "cve") {
					const all = this.countAdvisoriesWithExclusionType(report.advices, "cve");
					let counter = all;
					for (const advice of report.advices) {
						if (!advice.exclusions) {
							advice.exclusions = []
						}
						if (!advice.cve || !advice.cve === "N/A") {
							counter--;
							continue;
						}
						for (const exclusion of advice.exclusions) {
							if (exclusion.source === "security:cves") {
								await removeMitigation(exclusion.id, false, counter === all, counter === 0, this.state.doRecompute);
							}
							counter--;
						}
					}
				}

				this.globalExclusion = false
			}
			else {
				// if(this.type==="library"){
				// 	const libraryExclusion = report.advices[0].exclusions.reduce((exclusion,current)=>{
				// 		const isSameName=exclusions[current].library.name===exclusionElement.library;
				// 		const isSameLanguage=exclusions[current].library.language===exclusionElement.language;
				// 		const isSameVersion=(exclusions[current].version==="*" || exclusions[current].version) && exclusionElement.version;
				// 		if( isSameName && isSameLanguage && isSameVersion ) exclusion=current
				// 		return exclusion
				// 	},null)
				// 	if(libraryExclusion){
				// 		if(exclusions[libraryExclusion].version==="*"){
				// 			confirmedExclusion=libraryExclusion;
				// 			$("#exclude-confirm-dialog").modal("toggle");
				// 			return;
				// 		}
				// 		await removeMitigation(libraryExclusion, true, this.state.doRecompute, this.state.doRecompute)
				// 	}
				// }
				// else{	
				const transitive = exclusionElement.report && exclusionElement.report.transitiveExclusions && exclusionElement.report.transitiveExclusions.length
				await removeMitigation(exclusionElement.uuid, transitive, true, true, this.state.doRecompute)
				// }
			}
		}
		else {
			const { uuid } = exclusionElement;
			await removeMitigation(uuid, false, true, true, this.state.doRecompute);
		}
		this.type = null
	}

	changeTypeSelection = (e) => {
		this.type = e.target.value;
		this.setState({ id: this.state.id + 1 })
	}


	setRecomputeEvent(e) {
		const checked = e.target.checked
		this.setState({
			doRecompute: checked
		})
	}

	getSnapshotBeforeUpdate(prevProps) {
		const prevExclusionElement = JSON.stringify(prevProps.exclusionElement)
		const thisExclusionElement = JSON.stringify(this.props.exclusionElement)

		if (this.props.exclusionElement && this.props.action !== "remove") return false
		return prevExclusionElement !== thisExclusionElement
	}
	componentDidUpdate(prevProps, prevState, updated) {
		if (!updated || !this.autoRecompute || !this.autoRecompute.current) return
		const hasTransitiveExclusions = this.props.exclusionElement.report && this.props.exclusionElement.report.transitiveExclusions && this.props.exclusionElement.report.transitiveExclusions.length
		if (hasTransitiveExclusions) {
			this.autoRecompute.current.checked = true
			this.autoRecompute.current.disabled = true
		}
		else {
			this.autoRecompute.current.disabled = false
		}

		this.setRecomputeEvent({ target: this.autoRecompute.current })
	}


	render() {

		const { isGlobalExclusionAvailable, exclusionElement, shouldSetDefaultState } = this.props;
		const choices = exclusionElement.choices;

		if (!this.type && choices) this.type = choices[0];

		if (shouldSetDefaultState) this.setDefault();
		const { domain } = exclusionElement;
		let globalExclusionMessage = "";
		if (isGlobalExclusionAvailable) {

			if (this.type === "advice") {
				globalExclusionMessage = "Remove all the vulnerability exclusions related to this component"
			}
			if (this.type === "cve") {
				globalExclusionMessage = "Remove all the CVEs exclusions related to this component"
			}

		}
		return (
			<div className="modal fade" id="confirm" >
				<div className="modal-dialog modal-dialog-centered" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h4 className="modal-title">Delete a mitigation</h4>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>
						{exclusionElement && exclusionElement.text?
						<div className="modal-body" id="confirm-text">
							{exclusionElement.text}<br /><br />
							{domain === "security" && choices.length > 1 ?
								<div>
									{choices.includes("advice") ? <React.Fragment><input type="radio" name="type" value="advice" defaultChecked onChange={this.changeTypeSelection} /><label className="ml-1 mr-2">Vulnerability</label></React.Fragment> : ""}
									{choices.includes("cve") ? <React.Fragment><input type="radio" name="type" value="cve" onChange={this.changeTypeSelection} /><label className="ml-1 mr-2">CVE</label></React.Fragment> : ""}
									{choices.includes("library") ? <React.Fragment><input type="radio" name="type" value="library" onChange={this.changeTypeSelection} /><label className="ml-1 mr-2">Library version</label></React.Fragment> : ""}
								</div>
								: ""
							}
							{this.type === "advice" && isGlobalExclusionAvailable[this.type] ?
								<React.Fragment>
									<input type="checkbox" ref={this.excludeComponent} onChange={(e) => this.setGlobalExclusion(e)} className="mr-1" /> {globalExclusionMessage}
									<br />
								</React.Fragment>
								: null
							}
							<input ref={this.autoRecompute} type="checkbox" onChange={(e) => { this.setRecomputeEvent(e) }} className="mr-1" /> Automatically recompute the report

						</div>:null
						}
						<div className="modal-footer">
							<button type="button" data-dismiss="modal" className="btn btn-primary" id="delete" onClick={() => this.doRemoveMitigation(exclusionElement)}>Demitigate</button>
							<button type="button" data-dismiss="modal" className="btn">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
})














class Modals extends React.Component {


	matchObjects = (obj, source) => {
		return JSON.stringify(obj) === JSON.stringify(source);
	}

	componentDidMount(){
		window.$(".user-modal").off("hide.bs.modal").off("keydown")
		.on("keydown", e=> {
			window.userModalClosedByEsc = e.keyCode===27
		})
		.on("hide.bs.modal",(event)=>{
			event.closedByEsc = window.userModalClosedByEsc
			window.userModalClosedByEsc = false
			if(!event.closedByEsc) return
			if(!this.props.confirmModal.confirmCb) return 
				this.props.showCloseModalConfirmation(true)
			window.$("#close-modal-confirmation").modal("show")
			window.$(".modal-backdrop.fade.show")[0].classList.add("dim-modal")
			event.preventDefault()
		})
	}

	render() {
		const { isGlobalExclusionAvailable, exclusionElement, licenseToFix , setLicenseToFix} = this.props;
		const exclusionDomain = exclusionElement.domain;

		const shouldSetDefaultState = exclusionElement && exclusionElement.title && exclusionElement.title.length && !this.matchObjects(this.exclusionElement, exclusionElement)
		this.exclusionElement = exclusionElement;

		return (
			<React.Fragment>
				<Loader />
				<ModalCloseConfirmation setCloseModalConfirmCb={this.props.setCloseModalConfirmCb}/>
				<Demitigator
					shouldSetDefaultState={shouldSetDefaultState}
					isGlobalExclusionAvailable={isGlobalExclusionAvailable}
					exclusionElement={exclusionElement}
					removeMitigation={this.props.removeMitigation}
					action={this.props.action}
				/>
				<DemitigatorConfirm removeMitigation={this.props.removeMitigation} />

				<Mitigator
					shouldSetDefaultState={shouldSetDefaultState}
					isGlobalExclusionAvailable={isGlobalExclusionAvailable}
					exclusionElement={exclusionElement}
					domain={exclusionDomain}
					mitigate={this.props.mitigate}
					action={this.props.action}
					isMultiple={this.props.isMultiple}
					setCloseModalConfirmCb={this.props.setCloseModalConfirmCb}
					confirmModal={this.props.confirmModal}
					accountInfo={this.props.accountInfo}
				/>

				<LicenseFixer
					shouldSetDefaultState={shouldSetDefaultState}
					licenseToFix={licenseToFix}
					fixLicense={this.props.fixLicense} 
					setLicenseToFix={setLicenseToFix}
					showCloseModalConfirmation={this.props.showCloseModalConfirmation}
					confirmModal={this.props.confirmModal}
					setCloseModalConfirmCb={this.props.setCloseModalConfirmCb}
				/>

				<ReportRemover />
				<ReportRemoverConfirm />

				{this.props.historyData && this.props.historyData.selected ? <HistoryDetails uuid={this.props.historyData.selected} loadPage={this.props.loadPage} /> : null}
				<LicenseCopyright setCopyrightLicense={this.props.setCopyrightLicense} library={this.props.library} setCloseModalConfirmCb={this.props.setCloseModalConfirmCb}/>

				<JiraIssueModal accountInfo={this.props.accountInfo} loadPage={this.props.loadPage} setAlertMessage={this.props.setAlertMessage}/>

				<LocationsModal />

				<ApproveLibraryModal />
			</React.Fragment>
		)
	}
}

export default connect(mapStateToProps, mapDispatchAsProps)(Modals);